module.exports = __webpack_public_path__ + "img/purple-2-oval-striped.e02ae8a6.svg";